import styled from 'styled-components';

import { Row } from 'components/ui/Grid';


export const Wrapper = styled(Row)`
  justify-content: space-between;
  position: relative;
`;